import { render } from "./VideoBubble.vue?vue&type=template&id=2cd0e76b&scoped=true"
import script from "./VideoBubble.vue?vue&type=script&lang=js"
export * from "./VideoBubble.vue?vue&type=script&lang=js"

import "./VideoBubble.vue?vue&type=style&index=0&id=2cd0e76b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd0e76b"]])

export default __exports__